/** @format */

import {TanStackTableData} from 'components/Table/core/types';

interface ExportCampaignStatisticsParams {
  data: TanStackTableData[];
  companyName: string;
  startDate: string;
  endDate: string;
}

import {sanitizeFileName} from 'helpers/fileHelpers';

const EXCEL_HEADERS: Record<string, string> = {
  title: 'Название',
  id: 'ID',
  subAccount: 'Субаккаунт',
  mediaplanType: 'Тип',
  spent: 'Расход, \u20BD',
  impressions: 'Показы',
  clicks: 'Клики',
  ctr: 'CTR, %',
  cpc: 'CPC, \u20BD',
  conversions: 'Лиды',
  cpl: 'CPL, \u20BD',
  ePurchaseConversions: 'Заказы',
  revenue: 'Доход, \u20BD',
  drr: 'ДРР, %',
};

const COLUMN_ORDER = [
  'title',
  'id',
  'subAccount',
  'mediaplanType',
  'spent',
  'impressions',
  'clicks',
  'ctr',
  'cpc',
  'conversions',
  'cpl',
  'ePurchaseConversions',
  'revenue',
  'drr',
];

const mapRowToExcelData = (row: TanStackTableData): Record<string, string | number> => {
  const result: Record<string, string | number> = {};
  for (const key of COLUMN_ORDER) {
    const header = EXCEL_HEADERS[key] ?? key;
    const value = row[key];
    result[header] = typeof value === 'string' || typeof value === 'number' ? value : '';
  }
  return result;
};

export const exportCampaignStatisticsToExcel = async ({
  data,
  companyName,
  startDate,
  endDate,
}: ExportCampaignStatisticsParams): Promise<void> => {
  if (data.length === 0) return;

  const XLSX = await import('xlsx');

  const excelData = data.map(row => mapRowToExcelData(row));

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Campaign Statistics');

  const safeCompanyName = sanitizeFileName(companyName);
  const fileName = `campaign_statistics_${safeCompanyName}_${startDate}_${endDate}.xlsx`;

  XLSX.writeFile(workbook, fileName);
};
